import { Cities } from '@/types/cities';
import { Neighborhoods } from '@/types/neighborhoods';
import { States } from '@/types/states';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface LocationState {
	cities: Cities[];
	neighborhoods: {
		cityId: string;
		data: Neighborhoods[];
	};
	states: States[];
	updateCities: (cities: Cities[]) => void;
	updateNeighborhoods: (cityId: string, data: Neighborhoods[]) => void;
	updateStates: (states: States[]) => void;
}

const persistConfig = {
	name: 'gurupass-location',
};

export const useLocationStore = create<LocationState>()(
	persist(
		devtools(set => ({
			cities: [],
			neighborhoods: {
				cityId: '',
				data: [],
			},
			states: [],
			updateCities: (cities: Cities[]) => set({ cities }),
			updateNeighborhoods: (cityId: string, data: Neighborhoods[]) =>
				set({ neighborhoods: { cityId, data } }),
			updateStates: (states: States[]) => set({ states }),
		})),
		persistConfig
	)
);

if (global.window && (global.window as any).Cypress) {
	const initialState = (global.window as any).initialState;
	if (initialState) {
		useLocationStore.setState(initialState);
	}
	(window as any).locationStore = useLocationStore;
}

export default useLocationStore;
